import type { BuildPresentationProps } from '@features/lci-report/subdomains/visitation/utils/build-presentation';
import type { Slide } from '@features/powerpoint';
import { appendixTitleSlideV2 } from '../../../../../slides/appendix/appendix-title-slide-v2';
import { calculationsSlidesV2 } from '../../../../../slides/appendix/calculations/slides-v2';
import { glossarySlidesV2 } from '../../../../../slides/appendix/glossary/slides-v2';
import { lciGuidelineMinimumsSlideV2 } from '../../../../../slides/appendix/lci-guideline-minimums/slide-v2';
import { talkToUsSlideV2 } from '../../../../../slides/appendix/talk-to-us-slide-v2';
import { howWeDoItSlideV2 } from './how-we-do-it-slide';
import { visitLiftSummaryTableV2 } from './dimension-tables/visit-lift-summary-table';
import { salesLiftSummaryTableV2 } from './dimension-tables/sales-lift-summary-table';
import {
  GLOSSARY,
  CALCULATIONS,
} from '@features/glossary/subdomains/visitation';
import { MASTER_NAMES } from '../../../../../utils/shared-presentation-config-v2';
import { Calculations } from '@/features/glossary';

const VISIT_CALCULATIONS = {
  visitAttribution: CALCULATIONS.visitAttribution,
  projectedVisits: CALCULATIONS.projectedVisits,
};

const salesLiftItems = CALCULATIONS.salesLift.items;

const SALES_CALCULATIONS = {
  salesLiftLeft: {
    label: '',
    items: {
      transactionSize: salesLiftItems.transactionSize,
      incrementalSales: salesLiftItems.incrementalSales,
      incrementalSalesLift: salesLiftItems.incrementalSalesLift,
      returnOnAdSpend: salesLiftItems.returnOnAdSpend,
    },
  },
  salesLiftRight: {
    label: '',
    items: {
      incrementalReturnOnAdSpend: salesLiftItems.incrementalReturnOnAdSpend,
      transactionRate: salesLiftItems.transactionRate,
      penetration: salesLiftItems.penetration,
      salesRate: salesLiftItems.salesRate,
      totalProjectedSales: salesLiftItems.totalProjectedSales,
    },
  },
} as const satisfies Calculations;

export const appendixSlidesFromPropsV2 = (
  props: BuildPresentationProps
): Slide[] =>
  props.customFields.includedSlides.appendix
    ? [
        appendixTitleSlideV2(),
        ...visitLiftSummaryTableV2({
          slideMaster: MASTER_NAMES.titleAndContentNoLogo,
          overallVisitMetrics: props.visitMetrics,
          dimensionTableData: props.dimensionTableData,
          calculatedFields: props.calculatedFields,
          customFields: props.customFields.dimensions,
        }),
        ...(props.salesSummary
          ? salesLiftSummaryTableV2({
              slideMaster: MASTER_NAMES.titleAndContentNoLogo,
              overallVisitMetrics: props.visitMetrics,
              overallSalesMetrics: props.salesSummary,
              dimensionTableData: props.dimensionTableData,
              customFields: props.customFields.dimensions,
            })
          : []),
        ...glossarySlidesV2({
          entriesPerColumn: [8, 7, 8, 11],
          glossary: GLOSSARY,
        }),
        ...calculationsSlidesV2(
          VISIT_CALCULATIONS,
          {
            entriesPerColumnPerPage: [4, 3],
            totalPages: 1,
          },
          { title: 'Visitation Calculations' }
        ),
        ...calculationsSlidesV2(
          SALES_CALCULATIONS,
          {
            entriesPerColumnPerPage: [4, 5],
            totalPages: 1,
          },
          { title: 'Sales Lift Calculations' }
        ),
        howWeDoItSlideV2(),
        lciGuidelineMinimumsSlideV2(),
        talkToUsSlideV2(),
      ]
    : [];
